module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "team-location-upsell-illustration-2x.6f97ad6e.png" + "?" + Date.now();